import { Controller } from '@hotwired/stimulus';

import ProjectionGraphController from './projection-graph-controller';

export default class extends Controller {
  static targets = ['projectionGraph'];

  declare projectionGraphTarget: HTMLElement;

  handleTabChange() {
    this.projectionGraphController.draw();
  }

  get projectionGraphController() {
    return this.application.getControllerForElementAndIdentifier(
      this.projectionGraphTarget,
      'projection-graph'
    ) as ProjectionGraphController;
  }
}
